import React, { Fragment } from 'react';
import styles from './index.less';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import i18n from '@i18next/i18n';
import Tabs from '@tencent/dui/esm/components/Tabs';
import Button from '@tencent/dui/esm/components/Button';
import {
    DetailHeader,
} from '@src/slide/application/service/change-template-service/component/template-preview-list/detail-header';
import { PreviewTemplateContainer } from '@com-pc/preview-template-container';
import { E_SELECTED_KEY } from '@src/slide/application/service/change-template-service/index.interface';

export interface ISelectedScaleList {
    [selectedIndex: number]: boolean;
}

interface ITemplatePreviewListProps {
    selectedTemplateId: string;
    cloneUiDataService: IUiDataService;
    templateUiDataService?: IUiDataService;
    slideWidth: number;
    slideHeight: number;
    isLoading: boolean;
    showVipGuideButton: boolean;
    isVipTemplate: boolean;
    onUndo();
    onClick();
}

enum E_TAB_ID {
    USER_DOC = '0',
    TEMPLATE = '1',
}

interface ITemplatePreviewListState {
    activeId: E_TAB_ID;
    colNumber: number;
    previewMode: E_SELECTED_KEY;
}

/**
 * 主题预览列表
 */
export class TemplatePreviewList extends React.Component<ITemplatePreviewListProps, ITemplatePreviewListState> {
    constructor(props: ITemplatePreviewListProps) {
        super(props);
        this.state = {
            colNumber: 1,
            activeId: E_TAB_ID.USER_DOC,
            previewMode: E_SELECTED_KEY.BIG,
        };
    }

    /* eslint-disable complexity */
    public render() {
        const {
            cloneUiDataService,
            slideWidth,
            slideHeight,
            templateUiDataService,
            selectedTemplateId,
            isLoading,
            showVipGuideButton,
            isVipTemplate,
        } = this.props;
        const {
            slideWidth: templateWidth = 1920,
            slideHeight: templateHeight = 1080,
        } = templateUiDataService?.presentation?.props || {};

        return <div className={styles['template-preview-container']}>
            {
                selectedTemplateId && <div
                    className={styles['template-ok-container']}
                ><div
                        className={styles['template-select-ok']}
                    >
                        {
                            <Button
                                onClick={this.props.onClick}
                                disabled={isLoading}
                                type={isVipTemplate ? 'golden' : 'primary'}
                                style={{
                                    width: showVipGuideButton ? 164 : 151,
                                }}
                            >
                                {
                                    showVipGuideButton ? i18n.t('开通超级会员免费使用') : i18n.t('应用美化')
                                }
                            </Button>
                        }
                    </div>
                    <div className={styles['template-select-ok-append']} /></div>
            }
            <div className={styles['template-preview-list-container']}>
                <Tabs
                    onChange={(key) => {
                        const activeId = key as E_TAB_ID;
                        this.setState({
                            activeId,
                        });
                    }}
                    alignment={'left'}
                    indicatorWidth={'small'}
                    activeId={this.state.activeId}
                    activeItemStyle={{
                        color: '#1E6FFF',
                    }}
                    indicatorStyle={{
                        background: '#1E6FFF',
                    }}
                    tabBarSize={'medium'}>
                    <Tabs.TabPane
                        forceRender={true}
                        tab={i18n.t('效果预览')} id={E_TAB_ID.USER_DOC}>
                        <div className={styles['preview-container']}>
                            {

                                this.state.activeId === E_TAB_ID.USER_DOC && <DetailHeader
                                    selectedTemplateId={this.props.selectedTemplateId}
                                    isLoading={this.props.isLoading}
                                    showUndo={true}
                                    onUndo={this.props.onUndo}
                                    title={i18n.t('效果预览')}
                                    showSelectAll={true}
                                    previewMode={this.state.previewMode}
                                    onSelect={(previewMode) => {
                                        this.setState({
                                            previewMode,
                                        });
                                    }}
                                />
                            }
                            <div style={{
                                height: 498,
                            }}>
                                <PreviewTemplateContainer
                                    mode={this.state.previewMode}
                                    originSlideWidth={slideWidth}
                                    originSlideHeight={slideHeight}
                                    showBorder={true}
                                    uiDataService={cloneUiDataService}
                                    slideList={cloneUiDataService?.presentation?.children || []}
                                />
                            </div>
                        </div>
                    </Tabs.TabPane>
                    {
                        (templateUiDataService && selectedTemplateId) ? <Tabs.TabPane
                            forceRender={true}
                            tab={i18n.t('模版详情')}
                            id={E_TAB_ID.TEMPLATE}>
                            <div className={styles['preview-container']}>
                                {

                                    this.state.activeId === E_TAB_ID.TEMPLATE && <DetailHeader
                                        selectedTemplateId={this.props.selectedTemplateId}
                                        isLoading={this.props.isLoading}
                                        showUndo={false}
                                        title={i18n.t('效果预览')}
                                        showSelectAll={true}
                                        previewMode={this.state.previewMode}
                                        onSelect={(previewMode) => {
                                            this.setState({
                                                previewMode,
                                            });
                                        }}
                                    />
                                }
                                <div style={{
                                    height: 530,
                                }}>
                                    <PreviewTemplateContainer
                                        mode={this.state.previewMode}
                                        originSlideWidth={templateWidth}
                                        originSlideHeight={templateHeight}
                                        showBorder={true}
                                        uiDataService={templateUiDataService}
                                        slideList={templateUiDataService?.presentation?.children || []}
                                    />
                                </div>
                            </div>
                        </Tabs.TabPane> : <div />
                    }
                </Tabs>
            </div>
        </div>;
    }
}
